import type { Root } from 'hast';
import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';

export const rehypeExternalLinks: Plugin<[], Root> = function () {
  return function (tree) {
    visit(tree, { type: 'element', tagName: 'a' }, (node) => {
      // Add or modify properties on the 'properties' object
      node.properties.rel = 'noopener noreferrer';
      node.properties.target = '_blank';
    });
  };
};

export default rehypeExternalLinks;
